import collectiveApi from '../collectiveApi';
import { Document, DocumentResponse } from '../interfaces/documents';

import { localViews } from 'modules/Auth/AuthProvider/views';
import { fetchDocumentFile } from 'modules/Documents/api/documents';

export const searchDocuments = async (requestData = {}) => {
    const { data } = await collectiveApi.post<DocumentResponse>('documents/search', requestData, {
        params: {
            page: 1,
            page_size: 100, // Endpoint accepts max 100 items per page
        },
    });

    return data.results;
};

export const downloadDocument = async (uuid: string) => {
    const isEmployeeView = localViews.isEmployee();
    const { data } = await fetchDocumentFile(isEmployeeView, { uuid } as Document);
    return data;
};

export const deleteDocument = async (id: string, isEmployee = true) => {
    const endpoint = isEmployee ? 'ms-member-documents' : 'member-documents';
    const { data } = await collectiveApi.delete<DocumentResponse>(`/documents/${endpoint}/${id}/`);

    return data.results;
};
